import React from 'react'
import Contents from 'components/Slides/Contents'

export default Contents({
  heading: () => <span>This week in WordPress…</span>,
  points: [
    'Understand loops and templates in WordPress',
    'How to customise our posts to look how we want',
    'Adding a custom navigation to our page',
    'Styling our cool mat theme using HTML + CSS',
  ],
})



// WEBPACK FOOTER //
// ./src/slides/wordpress/cool-mat-week-2/slides/03-this-week.js